import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
import { useAppSettings } from '@!/Hooks/useAppSettings'
const MonthlyCourseUnregisterComplete = lazy(() => import('@!/User/MonthlyCourseUnregister/containers/MonthlyCourseUnregisterComplete'))

const MonthlyCourseUnregisterApp = () => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <MonthlyCourseUnregisterComplete />
      </Suspense>
    </AppProvider>
  )
}

export default MonthlyCourseUnregisterApp
